import { useQuery } from '@tanstack/react-query';
import { getLandlordTenants } from 'Services';
import { RQ_TENANTS } from 'Utils';
import { useTranslation } from 'react-i18next';
import { transformTenants } from 'Hooks/query-hooks/helper';

const useGetTenants = () => {
    const { t } = useTranslation();
    return useQuery([RQ_TENANTS], () => getLandlordTenants(), {
        select: (tenantsData) => {
            return transformTenants(t, tenantsData);
        }
    });
};

export default useGetTenants;
